<script lang="ts">
	import { home_data } from 'src/stores/account/user';
	import { onlyLocalRequests } from 'src/stores/session/only-local-requests';
	import { save_home } from 'src/helpers/home_helpers';
	import { ButtonGroup, Button } from '@Shelly/shelly-design-system';

	const buttons = [
		{ text: 'on', value: 1 },
		{ text: 'off', value: 0 },
	];
</script>

<!-- <ButtonGroup class="mr-s" slot="first"> -->
{#each buttons as button}
	<Button
		class="mr-s"
		size="m"
		variant={$onlyLocalRequests == button.value ? 'primary' : 'secondary'}
		on:click={() => onlyLocalRequests.set(button.value)}>{button.text}</Button
	>
{/each}
<!-- </ButtonGroup> -->
